<main class="home-main">

  <!-- ─── HERO ─── -->
  <section class="hero">
    <div class="hero-inner">

      <div class="hero-text">
        <span class="hero-badge">
          <i class="fas fa-truck"></i>
          {{ 'HOME.HERO.BADGE' | translate }}
        </span>
        <h1 class="hero-title">
          {{ 'HOME.HERO.TITLE' | translate }}<br>
          <span class="hero-accent">{{ 'HOME.HERO.TITLE_ACCENT' | translate }}</span>
        </h1>
        <p class="hero-subtitle">{{ 'HOME.HERO.SUBTITLE' | translate }}</p>
        <div class="hero-actions">
          <a href="/tracking" class="btn-hero-primary">
            <i class="fas fa-search-location"></i>
            {{ 'HOME.HERO.CTA_TRACK' | translate }}
          </a>
          <a href="/login" class="btn-hero-secondary">
            {{ 'HOME.HERO.CTA_LOGIN' | translate }}
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>

      <div class="hero-visual">
        <div class="tracking-card">
          <div class="tracking-card-header">
            <div class="tracking-card-icon"><i class="fas fa-box"></i></div>
            <div>
              <div class="tracking-card-label">Spedizione</div>
              <div class="tracking-card-code">ABC-123456789-0</div>
            </div>
            <span class="tracking-badge">In consegna</span>
          </div>
          <div class="tracking-steps">
            <div class="tracking-step done">
              <div class="step-dot"></div>
              <div class="step-line"></div>
              <span>Preso in carico</span>
            </div>
            <div class="tracking-step done">
              <div class="step-dot"></div>
              <div class="step-line"></div>
              <span>In transito</span>
            </div>
            <div class="tracking-step active">
              <div class="step-dot"></div>
              <div class="step-line"></div>
              <span>In consegna</span>
            </div>
            <div class="tracking-step">
              <div class="step-dot"></div>
              <div class="step-line last"></div>
              <span>Consegnato</span>
            </div>
          </div>
        </div>

        <div class="hero-pill pill-deliveries">
          <i class="fas fa-check-circle"></i>
          <div>
            <strong>###</strong>
            <span>consegne oggi</span>
          </div>
        </div>
        <div class="hero-pill pill-vehicles">
          <i class="fas fa-shipping-fast"></i>
          <div>
            <strong>###</strong>
            <span>veicoli attivi</span>
          </div>
        </div>

        <!-- Altri elementi di logistica flottanti attorno alla card: pill con dato e
             chip con la sola icona (nascosti sotto i 640px per non affollare la card) -->
        <div class="hero-pill pill-warehouse">
          <i class="fas fa-warehouse"></i>
          <div>
            <strong>###</strong>
            <span>colli in magazzino</span>
          </div>
        </div>
        <div class="hero-pill pill-eta">
          <i class="fas fa-clock"></i>
          <div>
            <strong>##:##</strong>
            <span>consegna stimata</span>
          </div>
        </div>
        <div class="hero-chip chip-barcode" title="Codice collo"><i class="fas fa-barcode"></i></div>
        <div class="hero-chip chip-pin" title="Posizione"><i class="fas fa-map-marker-alt"></i></div>
        <div class="hero-chip chip-dolly" title="Movimentazione"><i class="fas fa-dolly"></i></div>
        <div class="hero-chip chip-truck" title="Trasporto su strada"><i class="fas fa-truck"></i></div>
        <div class="hero-chip chip-plane" title="Trasporto aereo"><i class="fas fa-plane"></i></div>
      </div>
    </div>

    <div class="hero-shape shape-1"></div>
    <div class="hero-shape shape-2"></div>
  </section>

  <!-- ─── QUICK TRACK ─── -->
  <section class="quicktrack">
    <div class="quicktrack-card">
      <div class="quicktrack-head">
        <div class="quicktrack-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="quicktrack-heading">
          <h2 class="quicktrack-title">{{ 'HOME.QUICKTRACK.LABEL' | translate }}</h2>
          <p class="quicktrack-subtitle">{{ 'HOME.QUICKTRACK.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <form class="quicktrack-form" (ngSubmit)="goToTracking()">
        <div class="quicktrack-field">
          <i class="fas fa-barcode quicktrack-field-icon"></i>
          <input
            type="text"
            class="quicktrack-input"
            [(ngModel)]="trackingCode"
            name="trackingCode"
            autocomplete="off"
            [placeholder]="'HOME.QUICKTRACK.PLACEHOLDER' | translate"
          />
          <button
            type="button"
            class="quicktrack-clear"
            *ngIf="trackingCode"
            (click)="trackingCode = ''"
            [attr.aria-label]="'HOME.QUICKTRACK.CLEAR' | translate"
            [title]="'HOME.QUICKTRACK.CLEAR' | translate">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <button type="submit" class="quicktrack-btn">
          <i class="fas fa-search"></i>
          {{ 'HOME.QUICKTRACK.BUTTON' | translate }}
        </button>
      </form>

      <p class="quicktrack-hint">
        <i class="fas fa-info-circle"></i>
        {{ 'HOME.QUICKTRACK.HINT' | translate }}
      </p>
    </div>
  </section>

  <!-- ─── SERVICES ─── -->
  <section class="services-section">
    <div class="services-inner">
      <h2 class="section-heading">{{ 'HOME.SERVICES.TITLE' | translate }}</h2>
      <div class="services-grid">

        <a class="service-card cat-tracking" href="/tracking">
          <div class="service-icon"><i class="fas fa-truck"></i></div>
          <div class="service-text">
            <h3>{{ 'HOME.CARDS.TRACKING.TITLE' | translate }}</h3>
            <p>{{ 'HOME.CARDS.TRACKING.DESCRIPTION' | translate }}</p>
          </div>
          <div class="service-arrow"><i class="fas fa-arrow-right"></i></div>
        </a>

        <a class="service-card cat-contacts" href="/contacts">
          <div class="service-icon"><i class="fas fa-address-book"></i></div>
          <div class="service-text">
            <h3>{{ 'HOME.CARDS.CONTACTS.TITLE' | translate }}</h3>
            <p>{{ 'HOME.CARDS.CONTACTS.DESCRIPTION' | translate }}</p>
          </div>
          <div class="service-arrow"><i class="fas fa-arrow-right"></i></div>
        </a>

        <a class="service-card cat-support" href="/support">
          <div class="service-icon"><i class="fas fa-headset"></i></div>
          <div class="service-text">
            <h3>{{ 'HOME.CARDS.SUPPORT.TITLE' | translate }}</h3>
            <p>{{ 'HOME.CARDS.SUPPORT.DESCRIPTION' | translate }}</p>
          </div>
          <div class="service-arrow"><i class="fas fa-arrow-right"></i></div>
        </a>

        <a class="service-card cat-portal" href="/login">
          <div class="service-icon"><i class="fas fa-sign-in-alt"></i></div>
          <div class="service-text">
            <h3>{{ 'HOME.CARDS.PORTAL.TITLE' | translate }}</h3>
            <p>{{ 'HOME.CARDS.PORTAL.DESCRIPTION' | translate }}</p>
          </div>
          <div class="service-arrow"><i class="fas fa-arrow-right"></i></div>
        </a>

      </div>
    </div>
  </section>

  <!-- ─── TRUST STRIP ─── -->
  <section class="trust-section">
    <div class="trust-inner">

      <div class="trust-item trust-live">
        <div class="trust-icon-wrap">
          <div class="trust-icon"><i class="fas fa-satellite-dish"></i></div>
          <span class="trust-pulse"></span>
        </div>
        <strong class="trust-title">{{ 'HOME.TRUST.ITEM1_LABEL' | translate }}</strong>
        <span class="trust-desc">{{ 'HOME.TRUST.ITEM1_DESC' | translate }}</span>
      </div>

      <div class="trust-item trust-secure">
        <div class="trust-icon-wrap">
          <div class="trust-icon"><i class="fas fa-shield-halved"></i></div>
        </div>
        <strong class="trust-title">{{ 'HOME.TRUST.ITEM2_LABEL' | translate }}</strong>
        <span class="trust-desc">{{ 'HOME.TRUST.ITEM2_DESC' | translate }}</span>
      </div>

      <div class="trust-item trust-support">
        <div class="trust-icon-wrap">
          <div class="trust-icon"><i class="fas fa-headset"></i></div>
        </div>
        <strong class="trust-title">{{ 'HOME.TRUST.ITEM3_LABEL' | translate }}</strong>
        <span class="trust-desc">{{ 'HOME.TRUST.ITEM3_DESC' | translate }}</span>
      </div>

    </div>
  </section>

  <!-- ─── COOKIE TOAST ─── -->
  <div *ngIf="showCookieToast" class="toast-container">
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-inner">
        <i class="fas fa-cookie-bite toast-cookie-icon"></i>
        <span class="toast-body">{{ 'HOME.COOKIES.MESSAGE' | translate }}</span>
        <button type="button" class="toast-accept" (click)="acceptCookies()">
          {{ 'HOME.COOKIES.ACCEPT' | translate }}
        </button>
        <button type="button" class="toast-close" aria-label="Close" (click)="acceptCookies()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

</main>
